import Checkbox from '@/app/components/common/Checkbox'
import Text from '@/app/components/common/Text'
import { STAY_OPTIONS } from '@/app/constants'
import { Filters } from '@/app/types'
import { useTranslations } from 'next-intl'
import { FC, useMemo } from 'react'

interface StayOptionsFilterProps {
	localValue: Filters
	showAllStayOptions: boolean
	handleStayOptionChange: (optionId: number, name: string) => void
	toggleStayOptionsView: () => void
	availableFilters: { [key: string]: number }
}

const StayOptionsFilter: FC<StayOptionsFilterProps> = ({
	localValue,
	showAllStayOptions,
	handleStayOptionChange,
	toggleStayOptionsView,
	availableFilters,
}) => {
	const filteredOptions = useMemo(() => {
		return STAY_OPTIONS.filter(
			(option) => availableFilters[option.id] && availableFilters[option.id] > 0
		).sort((a, b) => {
			// Sort by count in descending order
			return availableFilters[b.id] - availableFilters[a.id]
		})
	}, [availableFilters])

	const shouldExpandList = useMemo(() => {
		return localValue.stayOptions.some(
			(optionId) =>
				filteredOptions.findIndex((option) => option.id === optionId) >= 5
		)
	}, [localValue.stayOptions, filteredOptions])

	const t = useTranslations('Keywords')
	const tOptions = useTranslations('Filters.StayOptions')

	const optionsToShow =
		shouldExpandList || showAllStayOptions
			? filteredOptions
			: filteredOptions.slice(0, 5)

	if (filteredOptions.length === 0) return null

	return (
		<div className="hotel-list-filters__section">
			<Text size="lg" font={'bold'} className="mb-2 inline-block">
				{t('stayOptionsFilter')}
			</Text>
			<ul className="hotel-list-filters__stay-options">
				{optionsToShow.map(({ id, name }) => (
					<div
						key={id}
						className="hotel-list-filters__stay-options-item hotel-list-filters__item"
					>
						<Checkbox
							variant="main-dark"
							checked={localValue.stayOptions.includes(id)}
							testId={`stay-option-${id}`}
							onChange={() => handleStayOptionChange(id, name)}
							labelRight={`${tOptions(name)} (${availableFilters[id]})`}
							bold={false}
						/>
					</div>
				))}
			</ul>
			{!shouldExpandList && filteredOptions.length > 5 && (
				<button
					onClick={toggleStayOptionsView}
					className="text-tertiary-950 hover:underline mt-2 mb-2"
				>
					{showAllStayOptions ? t('seeLess') : t('seeMore')}
				</button>
			)}
		</div>
	)
}

export default StayOptionsFilter
